import { preprocessLithuanianText } from './lithuanianTtsPreprocess.js';

export const speak = (text, language = 'en') => {
  if (!('speechSynthesis' in window)) {
    console.warn('Speech synthesis not supported');
    return;
  }

  window.speechSynthesis.cancel();

  const ttsText =
    language === 'lt' ? preprocessLithuanianText(String(text)) : String(text);
  const utterance = new SpeechSynthesisUtterance(ttsText);
  utterance.lang = language === 'lt' ? 'lt-LT' : 'en-US';
  utterance.rate = 0.80; // Slower pace (0.80 = 80% speed) - ASD-friendly slower pacing, smooth
  utterance.pitch = 1;
  utterance.volume = 1;

  window.speechSynthesis.speak(utterance);
};

export const isSpeechSynthesisSupported = () => {
  return 'speechSynthesis' in window;
};

/**
 * Check if Speech Recognition API is supported
 * Per Web Speech API spec: supports both webkit (Chrome) and standard (future)
 * https://webaudio.github.io/web-speech-api/
 */
export const isSpeechRecognitionSupported = () => {
  return 'SpeechRecognition' in window || 'webkitSpeechRecognition' in window;
};